import { Visibility } from "../core/enums/Visibility";
import { ContactSearch } from "./contactSearch";
import { KeyValue } from "./system/KeyValueString";

export class AccessControl {
    members: ContactSearch[] = [];
    tenancies: KeyValue[] = [];
    visibility: Visibility = Visibility.Private;
}